import "../../styles/OnboardingScreen4.css";
import screen4Img from "../../assets/onboarding/screen4.png";

export default function OnboardingScreen4() {
  return (
    <div className="ob4">
      <div className="ob4Text">
        <h1>
          Разом смачніше.
          <br />
          Швидко у тебе
        </h1>
      </div>

      <div className="ob4ImageWrap">
        <img src={screen4Img} alt="Delivery and snacks" />
      </div>
    </div>
  );
}